
export class FullScreen
{
    static onChange(eventHandler : (isFullscreen : boolean) => void)
    {
	    let handler = () => {
			let fse = FullScreen.getFullScreenElement();
		    eventHandler(!!fse);
	    };

	    document.addEventListener('webkitfullscreenchange', handler, false);
	    document.addEventListener('mozfullscreenchange', handler, false);
	    document.addEventListener('fullscreenchange', handler, false);
	    document.addEventListener('MSFullscreenChange', handler, false);
    }

    static request(element : any)
    {
        if (element.requestFullscreen) element.requestFullscreen();
        else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
        else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
        else if (element.msRequestFullscreen) element.msRequestFullscreen();
    }

    static getFullScreenElement() : Element
    {
        if ((<any>document).fullscreenElement) return (<any>document).fullscreenElement;
        else if ((<any>document).msFullscreenElement) return (<any>document).msFullscreenElement;
        else if ((<any>document).webkitFullscreenElement) return (<any>document).webkitFullscreenElement;
        else if ((<any>document).mozFullScreenElement) return (<any>document).mozFullScreenElement;
        else return null;
    }

    static cancel()
    {
        if ((<any>document).exitFullscreen) (<any>document).exitFullscreen();
        else if ((<any>document).webkitExitFullscreen) (<any>document).webkitExitFullscreen();
        else if ((<any>document).mozCancelFullScreen) (<any>document).mozCancelFullScreen();
        else if ((<any>document).msExitFullscreen) (<any>document).msExitFullscreen();
    }

    static supported() : boolean
    {
        return !!(
            (<any>document).fullscreenEnabled ||
            (<any>document).webkitFullscreenEnabled ||
            (<any>document).mozFullScreenEnabled ||
            (<any>document).msFullscreenEnabled);
    }
}
